import { Injectable } from '@angular/core';

@Injectable()
export class AuthService {
  userInfo: any = null;
  authModules: any = null;
  constructor() { }

}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/auth/auth.service.ts